/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Jotkin API
 * LINE-driven calorie logging and dashboard API. This tool estimates calories for general wellness; it is not medical advice.
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  DishCandidateDto,
  ListCandidatesParams
} from '../model';

import { apiFetch } from '../../lib/api-fetch';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export const getListCandidatesUrl = (params?: ListCandidatesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/admin/candidates?${stringifiedParams}` : `/api/admin/candidates`
}

/**
 * Ordered by how often they were asked for, so demand drives the queue.
 * @summary Dishes awaiting review
 */
export const listCandidates = async (params?: ListCandidatesParams, options?: Parameters<typeof apiFetch>[1]): Promise<DishCandidateDto[]> => {

  return apiFetch<DishCandidateDto[]>(getListCandidatesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListCandidatesQueryKey = (params?: ListCandidatesParams,) => {
    return [
    `/api/admin/candidates`, ...(params ? [params] : [])
    ] as const;
    }


export const getListCandidatesQueryOptions = <TData = Awaited<ReturnType<typeof listCandidates>>, TError = void>(params?: ListCandidatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCandidates>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListCandidatesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listCandidates>>> = ({ signal }) => listCandidates(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listCandidates>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListCandidatesQueryResult = NonNullable<Awaited<ReturnType<typeof listCandidates>>>
export type ListCandidatesQueryError = void


export function useListCandidates<TData = Awaited<ReturnType<typeof listCandidates>>, TError = void>(
 params: undefined |  ListCandidatesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCandidates>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCandidates>>,
          TError,
          Awaited<ReturnType<typeof listCandidates>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListCandidates<TData = Awaited<ReturnType<typeof listCandidates>>, TError = void>(
 params?: ListCandidatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCandidates>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCandidates>>,
          TError,
          Awaited<ReturnType<typeof listCandidates>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListCandidates<TData = Awaited<ReturnType<typeof listCandidates>>, TError = void>(
 params?: ListCandidatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCandidates>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary Dishes awaiting review
 */

export function useListCandidates<TData = Awaited<ReturnType<typeof listCandidates>>, TError = void>(
 params?: ListCandidatesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listCandidates>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListCandidatesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export const getApproveCandidateUrl = (id: string,) => {




  return `/api/admin/candidates/${id}/approve`
}

/**
 * Idempotent: approving the same candidate twice updates the dish rather than creating a second one. Estimate-derived dishes stay unverified.
 * @summary Promote a candidate into the dish table
 */
export const approveCandidate = async (id: string, options?: Parameters<typeof apiFetch>[1]): Promise<DishCandidateDto> => {

  return apiFetch<DishCandidateDto>(getApproveCandidateUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getApproveCandidateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveCandidate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof approveCandidate>>, TError,{id: string}, TContext> => {

const mutationKey = ['approveCandidate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof approveCandidate>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  approveCandidate(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type ApproveCandidateMutationResult = NonNullable<Awaited<ReturnType<typeof approveCandidate>>>

    export type ApproveCandidateMutationError = void

    /**
 * @summary Promote a candidate into the dish table
 */
export const useApproveCandidate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof approveCandidate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof approveCandidate>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getApproveCandidateMutationOptions(options), queryClient);
    }
    export const getRejectCandidateUrl = (id: string,) => {




  return `/api/admin/candidates/${id}/reject`
}

/**
 * Stops the estimate cache from serving these macros again.
 * @summary Reject a candidate
 */
export const rejectCandidate = async (id: string, options?: Parameters<typeof apiFetch>[1]): Promise<DishCandidateDto> => {

  return apiFetch<DishCandidateDto>(getRejectCandidateUrl(id),
  {
    ...options,
    method: 'POST'


  }
);}





export const getRejectCandidateMutationOptions = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rejectCandidate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof rejectCandidate>>, TError,{id: string}, TContext> => {

const mutationKey = ['rejectCandidate'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof rejectCandidate>>, {id: string}> = (props) => {
          const {id} = props ?? {};

          return  rejectCandidate(id,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RejectCandidateMutationResult = NonNullable<Awaited<ReturnType<typeof rejectCandidate>>>

    export type RejectCandidateMutationError = void

    /**
 * @summary Reject a candidate
 */
export const useRejectCandidate = <TError = void,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof rejectCandidate>>, TError,{id: string}, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof rejectCandidate>>,
        TError,
        {id: string},
        TContext
      > => {
      return useMutation(getRejectCandidateMutationOptions(options), queryClient);
    }
